import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { GlobalService } from './_services/global.service';
import { FirmaBilgileri } from './_models/firmabilgileri';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'digi[SOFT]';
  aaa=false;
  constructor(private router:Router, @Inject(PLATFORM_ID) private platformId: Object) {

   }
  visible = false;
  placement = 'left';
  open(): void {
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }
  ngOnInit() {
   
    
    console.log('digi[SOFT] Yazılım ve Bilişim Teknolojileri')
    
     this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      if (isPlatformBrowser(this.platformId)) {
        // Sadece tarayıcıda çalışmasını istediğimiz kodlar burada yer alacak.
        // Örn: setTimeout, setInterval, localStorage, sessionStorage vb. komutlar bu if içerisinde olacak.
         window.scrollTo(0, 0)   //is platform browser

       }
  }); 


  }
}
